import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import 'element-plus/packages/theme-chalk/src/base.scss'
import { Swipe, SwipeItem , Grid, GridItem, Dialog, Toast, Calendar, Field } from 'vant';

// 2. 引入组件样式
import 'vant/lib/index.css';

// import 'element-plus/packages/theme-chalk/src/index.scss'
import installElementPlus from './plugins/element';
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = '学习部落云课堂';
    }
    next();
});

const app = createApp(App);
installElementPlus(app);
// 定义全局时间格式化方法
app.config.globalProperties.$formatDateTime = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
    const padStart = (value) => (value + '').padStart(2, '0');
    const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    const days = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];

    const year = date.getFullYear();
    const month = months[date.getMonth()];
    const day = days[date.getDate() - 1];
    const hour = padStart(date.getHours());
    const minute = padStart(date.getMinutes());
    const second = padStart(date.getSeconds());

    return format
        .replace('YYYY', year)
        .replace('MM', month)
        .replace('DD', day)
        .replace('HH', hour)
        .replace('mm', minute)
        .replace('ss', second);
};

app.use(Swipe);
app.use(SwipeItem);
app.use(Grid);
app.use(GridItem);
app.use(Dialog);
app.use(Toast);
app.use(Calendar);
app.use(Field);

app.use(router).mount('#app')